interface IconProps extends React.SVGProps<SVGSVGElement> {
    name: string;
    className?: string;
}

const spriteMap = {
    home: "/icons/sprite-top-nav.svg",
    favouriteStroke: "/icons/sprite-top-nav.svg",
    bonuses: "/icons/sprite-top-nav.svg",
    latestReleases: "/icons/sprite-top-nav.svg",
    challenges: "/icons/sprite-top-nav.svg",
    trophy: "/icons/sprite-top-nav.svg",
    slots: "/icons/sprite-bottom-nav.svg",
    popular: "/icons/sprite-bottom-nav.svg",
    stopwatch: "/icons/sprite-bottom-nav.svg",
    liveCasino: "/icons/sprite-bottom-nav.svg",
    blackjack: "/icons/sprite-bottom-nav.svg",
    roulette: "/icons/sprite-bottom-nav.svg",
    gameShows: "/icons/sprite-bottom-nav.svg",
    baccarat: "/icons/sprite-bottom-nav.svg",
    users: "/icons/sprite-bottom-nav.svg",
    liveSupport: "/icons/sprite-bottom-nav.svg",
    tableGames: "/icons/sprite-bottom-nav.svg",
    pt: "/icons/sprite-flags.svg",
    de: "/icons/sprite-flags.svg",
    en: "/icons/sprite-flags.svg",
    es: "/icons/sprite-flags.svg",
    ag: "/icons/sprite-flags.svg",
    cl: "/icons/sprite-flags.svg",
    pe: "/icons/sprite-flags.svg",
    mx: "/icons/sprite-flags.svg",
    fr: "/icons/sprite-flags.svg",
    br: "/icons/sprite-flags.svg",
    ru: "/icons/sprite-flags.svg",
    zh: "/icons/sprite-flags.svg",
    eighteenPlus: "/icons/sprite-common.svg",
    gamePad: "/icons/sprite-bonus-condition.svg",
    thresh: "/icons/sprite-bonus-condition.svg",
    wallet: "/icons/sprite-bonus-condition.svg",
    checkSuccess: "/icons/sprite-bonus-condition.svg",
};

export const Icon = ({name, className, width = 20, height = 20, ...props}: IconProps) => {

    const sprite = spriteMap[name as keyof typeof spriteMap];
    return (
        <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" fill={'none'} className={className} {...props}>
            <use href={`${sprite}#${name}`}/>
        </svg>
    );
};
